import styles from "./CustomButton.module.scss";

export const ButtonLoader: React.FC = () => {
  return (
    <div className={styles.buttonLoader}>
      <div className={styles.spinner} />
    </div>
  );
};
